import { connect } from 'react-redux'
import { findPermission, readOnly } from '../../../utils/permissions'
import { format } from '../../../utils'
import { listTableStyle } from '../../../styles'
import classNames from 'classnames'
import { ratingsActions, confirmActions, messageActions } from '../../../actions'
import { reloadTable } from '../../../utils/reloadTable'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import IconButton from '@material-ui/core/IconButton'
import ImageEdit from 'material-ui/svg-icons/image/edit'
import Paper from '@material-ui/core/Paper'
import React, { Component, Fragment } from 'react'
import TablePagination from '@material-ui/core/TablePagination'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import Typography from '@material-ui/core/Typography'
import Visibility from '@material-ui/icons/Visibility'

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'

class ListTable extends Component {
  state = {
    debounce: undefined
  }

  componentWillUpdate(newProps) {
    const { order, pagination, fetchContentRatings, term } = newProps
    const { page, rowsPerPage: perPage } = pagination

    const { ratingId } = this.props

    if (reloadTable(newProps, this.props)) {
      const debounce = setTimeout(() => {
        fetchContentRatings({ ratingId, page, perPage, order, term })
      }, 700)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }

    return true
  }

  componentDidMount() {
    const { fetchContentRatings, ratingId, order, pagination } = this.props
    const { page, rowsPerPage: perPage } = pagination

    fetchContentRatings({ ratingId, page, perPage, order })
  }

  renderActions = item => {
    const { fetchRating, token } = this.props

    return readOnly('avaliacoes', token) ? (
      <IconButton
        onClick={() => {
          fetchRating(item._id)
        }}
      >
        <Visibility nativeColor={'rgba(0, 0, 0, 0.87)'} />
      </IconButton>
    ) : (
      <Fragment>
        {findPermission('avaliacoes', token).editar && (
          <IconButton
            onClick={() => {
              fetchRating(item._id)
            }}
          >
            <ImageEdit />
          </IconButton>
        )}
      </Fragment>
    )
  }

  handleChangePage = (event, page) => {
    const { handleChangePage } = this.props
    handleChangePage(page)
  }

  handleChangeRowsPerPage = event => {
    const perPage = event.target.value
    const { handleChangePerPage } = this.props
    handleChangePerPage(perPage)
  }

  handleSortTable = column => {
    const { order, changeOrderColumn, changeOrderDirection } = this.props

    if (column === ((order || {}).column || '')) {
      const direction = ((order || {}).direction || 1) === -1 ? 1 : -1
      changeOrderDirection(direction)
    } else {
      changeOrderColumn(column)
    }
  }

  render() {
    const { classes, ratings, loadingRatings, pagination, order } = this.props

    return (
      <Paper
        className={classNames(classes.wrapperTable, classes.wrapperTableWithHeader)}
        elevation={4}
      >
        {!!loadingRatings && (
          <div className={classes.wrapperLoader}>
            <CircularProgress />
          </div>
        )}
        <Table
          fixedHeader={true}
          width={'990px'}
          wrapperStyle={{
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'var(--crud-table-height)'
          }}
        >
          <TableHeader
            displaySelectAll={false}
            className={classes.tableHeader}
            adjustForCheckbox={false}
          >
            <TableRow>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'createdAt'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('createdAt')
                  }}
                >
                  Data
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'nomeUsuario'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('nomeUsuario')
                  }}
                >
                  Usuário
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'emailUsuario'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('emailUsuario')
                  }}
                >
                  E-mail
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'tituloConteudo'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('tituloConteudo')
                  }}
                >
                  Conteúdo
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'nota'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('nota')
                  }}
                >
                  Nota
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'status'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('status')
                  }}
                >
                  Status
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '100px' }}>Ações</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false} className={classes.tableBody}>
            {(ratings || []).length ? (
              (ratings || []).map(content => {
                return (
                  <TableRow key={content._id}>
                    <TableRowColumn>{format.date(content.createdAt) || '--'}</TableRowColumn>
                    <TableRowColumn>{content.nomeUsuario || '--'}</TableRowColumn>
                    <TableRowColumn>{content.emailUsuario || '--'}</TableRowColumn>
                    <TableRowColumn>{content.tituloConteudo || '--'}</TableRowColumn>
                    <TableRowColumn>{content.nota || '--'}</TableRowColumn>
                    <TableRowColumn>{content.status || 'Nova'}</TableRowColumn>
                    <TableRowColumn style={{ width: '100px' }}>
                      {this.renderActions(content)}
                    </TableRowColumn>
                  </TableRow>
                )
              })
            ) : (
              <TableRow>
                <TableRowColumn>
                  <Typography noWrap style={{ textAlign: 'center', padding: '16px' }}>
                    {!!loadingRatings ? 'Carregando...' : 'Não há registros.'}
                  </Typography>
                </TableRowColumn>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <div className={classes.paginationWrapper}>
          <div className={classes.page}>Página: {pagination.page + 1}</div>
          <TablePagination
            component="div"
            className={classes.pagination}
            labelRowsPerPage="Itens por página"
            labelDisplayedRows={({ from, to, count, page }) => {
              return `Exibindo de ${from} a ${to} de ${count}`
            }}
            count={pagination.length}
            rowsPerPage={pagination.rowsPerPage}
            rowsPerPageOptions={[25, 50, 100]}
            page={pagination.page}
            backIconButtonProps={{
              'aria-label': 'Página anterior'
            }}
            nextIconButtonProps={{
              'aria-label': 'Próxima página'
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </div>
      </Paper>
    )
  }
}

const mapStateToProps = state => {
  return {
    loadingRatings: state.ratings.details.loading,
    order: state.ratings.details.order,
    pagination: state.ratings.details.ratingsPagination,
    rating: state.ratings.rating,
    ratings: state.ratings.details.ratings,
    term: state.searchTable.term,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(ratingsActions.openModal())
    },
    closeModal: () => {
      dispatch(ratingsActions.closeModal())
    },
    fetchRating: id => {
      dispatch(ratingsActions.fetchRating(id))
    },
    fetchContentRatings: id => {
      dispatch(ratingsActions.fetchContentRatings(id))
    },
    handleChangePage: page => {
      dispatch(ratingsActions.handleChangeDetailsPage(page))
    },
    handleChangePerPage: perPage => {
      dispatch(ratingsActions.handleChangeDetailsPerPage(perPage))
    },
    changeOrderColumn: column => {
      dispatch(ratingsActions.changeDetailsOrderColumn(column))
    },
    changeOrderDirection: direction => {
      dispatch(ratingsActions.changeDetailsOrderDirection(direction))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(listTableStyle)(ListTable))



// WEBPACK FOOTER //
// ./src/containers/Ratings/RatingDetails/ListTable.js